"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var PAdminProfileCtl = /** @class */ (function (_super) {
    __extends(PAdminProfileCtl, _super);
    function PAdminProfileCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this._errDialog = errDialog;
        return _this;
    }
    PAdminProfileCtl.prototype.ResetData = function () {
        this.DATA = {
            loaded: false,
            login: "",
            name: "",
            surname: "",
            email: "",
            phone: "",
            skype: ""
        };
    };
    PAdminProfileCtl.prototype.LoadData = function (force, onDone) {
        var _this = this;
        if ((force) || (!this.DATA.loaded)) {
            webAApi_1.DetailsActiveAdminGet.exec({}, function (resp) {
                _this.DATA.email = resp.email;
                _this.DATA.login = resp.login;
                _this.DATA.name = resp.name;
                _this.DATA.phone = resp.phone;
                _this.DATA.skype = resp.skype;
                _this.DATA.surname = resp.surname;
                _this.DATA.loaded = true;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
        else {
            this.Update();
            if (onDone) {
                onDone();
            }
        }
    };
    PAdminProfileCtl.prototype.EditActiveAdminProfile = function (editData, onDone) {
        var _this = this;
        webAApi_1.DoEditActiveAdminDetails.exec({
            name: editData.name,
            surname: editData.surname,
            email: editData.email,
            phone: editData.phone,
            skype: editData.skype
        }, function (resp) {
            _this.DATA.email = editData.email;
            _this.DATA.name = editData.name;
            _this.DATA.phone = editData.phone;
            _this.DATA.skype = editData.skype;
            _this.DATA.surname = editData.surname;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return PAdminProfileCtl;
}(BaseController_1.BaseController));
exports.PAdminProfileCtl = PAdminProfileCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/admin_profile/ctl/PAdminProfileCtl.ts
// module id = 863
// module chunks = 0